import apply from '@/localization/apply'
import { BlocksContent } from '@strapi/blocks-react-renderer'
import { ImageData } from './strapi.types'

export const applyParamsToBlockContent = (
  blocks: BlocksContent,
  params?: Record<string, string>,
): BlocksContent => {
  const blocksJson = JSON.stringify(blocks)
  const blocksParsed = JSON.parse(apply(blocksJson, params))

  return blocksParsed as BlocksContent
}

export function getFileInfo(fileData: ImageData) {
  const { name, mime, size } = fileData.attributes

  // Get format based on mime type
  const getFormat = (mime: string) => {
    // Handle Office documents
    if (mime.includes('presentationml.presentation')) return 'PPTX'
    if (mime.includes('spreadsheetml.sheet')) return 'XLSX'
    if (mime.includes('wordprocessingml.document')) return 'DOCX'

    // Handle other common formats
    if (mime.startsWith('image/')) return 'Image'
    if (mime.startsWith('video/')) return 'Video'
    if (mime === 'application/pdf') return 'PDF'
    if (mime === 'application/zip') return 'ZIP'
    if (mime === 'font/otf') return 'OTF'
    if (mime === 'font/ttf') return 'TTF'

    // Default case - take the last part of the mime type and convert to uppercase
    return mime.split('/')[1].toUpperCase()
  }

  // Get name without extension
  const nameWithoutExtension = name.substring(0, name.lastIndexOf('.')) || name

  return {
    name,
    nameWithoutExtension,
    sizeInKb: Math.round(size), // size is already in KB in the API response
    format: getFormat(mime),
  }
}
